import { createContext } from 'react';
import { TrackingFunction } from './tracking-utils';

export const TrackingFunctionContext = createContext<TrackingFunction>(() => {
  throw new Error(
    'No TrackingFunctionContext.Provider found in component tree'
  );
});

export const DebugErrorBoundaryContext = createContext<boolean>(false);
